export const themes = {
  default: {
    container: 'bg-white rounded-lg shadow-md p-6',
    title: 'text-2xl font-bold mb-6 text-gray-800',
    section: 'mb-6',
    fieldWrapper: 'mb-4',
    label: 'block text-lg font-medium text-gray-700 mb-1 ',
    input: 'w-full px-5 py-2 border-2 border-gray-800 rounded-[20px] focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all',
    inputError: 'border-red-500 focus:ring-red-500',
    error: 'text-red-500 text-xs mt-1 flex items-center',
    hint: 'text-gray-500 text-xs mt-1 text-left px-6',
    button: 'bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:bg-gray-400',
    secondaryButton: 'bg-gray-200 text-gray-700 px-6 py-2 rounded-md hover:bg-gray-300 transition-colors',
    successMessage: 'bg-green-100 text-green-700 p-3 rounded-md',
    errorMessage: 'bg-red-100 text-red-700 p-3 rounded-md',
    // Dropdown styling
    dropdown: {
      container: 'absolute z-50 w-full mt-1 bg-white border border-gray-200 rounded-[20px] shadow-lg overflow-auto',
      item: 'px-3 py-2 cursor-pointer transition-colors hover:bg-gray-50',
      itemHighlighted: 'px-3 py-2 cursor-pointer transition-colors bg-blue-50',
      itemLabel: 'font-medium text-gray-900',
      itemInfo: 'text-sm text-gray-500 mt-0.5',
      loadingContainer: 'px-3 py-4 text-center text-gray-500',
      loadingSpinner: 'animate-spin h-5 w-5 mx-auto mb-2',
      errorText: 'px-3 py-2 text-red-500 text-center',
      noResultsText: 'px-3 py-2 text-gray-500 text-center',
      promptText: 'px-3 py-2 text-gray-500 text-center'
    }
  },
  dark: {
    container: 'bg-gray-800 rounded-lg shadow-xl p-6',
    title: 'text-2xl font-bold mb-6 text-white',
    section: 'mb-6',
    fieldWrapper: 'mb-4',
    label: 'block text-sm font-medium text-gray-300 mb-1',
    input: 'w-full px-3 py-2 bg-gray-700 border border-gray-600 text-white rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all',
    inputError: 'border-red-500 focus:ring-red-500',
    error: 'text-red-400 text-xs mt-1 flex items-center',
    hint: 'text-gray-400 text-xs mt-1',
    button: 'bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors disabled:bg-gray-600',
    secondaryButton: 'bg-gray-600 text-white px-6 py-2 rounded-md hover:bg-gray-500 transition-colors',
    successMessage: 'bg-green-900 text-green-300 p-3 rounded-md',
    errorMessage: 'bg-red-900 text-red-300 p-3 rounded-md',
    // Dropdown styling
    dropdown: {
      container: 'absolute z-50 w-full mt-1 bg-gray-800 border border-gray-700 rounded-md shadow-lg overflow-auto',
      item: 'px-3 py-2 cursor-pointer transition-colors hover:bg-gray-700',
      itemHighlighted: 'px-3 py-2 cursor-pointer transition-colors bg-blue-900/30',
      itemLabel: 'font-medium text-gray-100',
      itemInfo: 'text-sm text-gray-400 mt-0.5',
      loadingContainer: 'px-3 py-4 text-center text-gray-400',
      loadingSpinner: 'animate-spin h-5 w-5 mx-auto mb-2',
      errorText: 'px-3 py-2 text-red-400 text-center',
      noResultsText: 'px-3 py-2 text-gray-400 text-center',
      promptText: 'px-3 py-2 text-gray-400 text-center'
    }
  },
  minimal: {
    container: 'bg-white p-6',
    title: 'text-xl font-light mb-6 text-gray-900',
    section: 'mb-6',
    fieldWrapper: 'mb-4',
    label: 'block text-xs uppercase tracking-wide text-gray-600 mb-2',
    input: 'w-full px-2 py-2 border-b border-gray-300 focus:border-gray-900 transition-all outline-none',
    inputError: 'border-red-500',
    error: 'text-red-500 text-xs mt-1 flex items-center',
    hint: 'text-gray-400 text-xs mt-1',
    button: 'bg-gray-900 text-white px-8 py-2 hover:bg-gray-800 transition-colors disabled:bg-gray-500',
    secondaryButton: 'border border-gray-900 text-gray-900 px-8 py-2 hover:bg-gray-100 transition-colors',
    successMessage: 'border-l-4 border-green-500 pl-3 py-2',
    errorMessage: 'border-l-4 border-red-500 pl-3 py-2',
    // Dropdown styling
    dropdown: {
      container: 'absolute z-50 w-full mt-2 bg-white border-t border-b border-gray-300 shadow-sm overflow-auto',
      item: 'px-2 py-2 cursor-pointer transition-colors hover:bg-gray-50',
      itemHighlighted: 'px-2 py-2 cursor-pointer transition-colors bg-gray-100',
      itemSelected: 'px-2 py-2 cursor-pointer transition-colors bg-gray-200',
      itemLabel: 'font-light text-gray-900',
      itemInfo: 'text-xs text-gray-500 mt-0.5',
      checkIcon: 'w-4 h-4 text-gray-700 ml-2 flex-shrink-0',
      loadingContainer: 'px-2 py-3 text-center text-gray-500',
      loadingSpinner: 'animate-spin h-4 w-4 mx-auto mb-1',
      errorText: 'px-2 py-2 text-red-500 text-center text-sm',
      noResultsText: 'px-2 py-2 text-gray-500 text-center text-sm',
      promptText: 'px-2 py-2 text-gray-500 text-center text-sm'
    }
  }
};